import {
  getSheetIdToTaggingTargetMap,
  useDsdTaskStatus,
} from "@/components/sidebar/hooks";
import { useCategoryId, useWorkbookId } from "@/hooks/use-workbook";

/**
 * 현재 열려 있는 시트가 셀 단위 태깅(오토태깅·롤포워드) 대상인지.
 *
 * 일반사항·회계정책·추정 등의 목차는 대상이 아니라 그 시트의 "표 오토태깅"·"하나의 표
 * 불러오기"를 잠근다. status(NOT_TARGET)로는 부족하다 — 규칙 도입 전에 이미 분석된
 * 일반사항·회계정책·추정 등의 목차는 COMPLETED 로 내려오므로 백엔드가 따로 주는 `taggingTarget` 을 본다.
 * 상태를 아직 못 받았으면 잠그지 않는다(로딩 중 버튼이 깜빡이지 않게).
 */
export function useIsCurrentSheetTaggingTarget(): boolean {
  const { data: workbookId } = useWorkbookId();
  const { data: categoryId } = useCategoryId();
  const { data: taskStatusData } = useDsdTaskStatus(workbookId ?? undefined);

  if (!taskStatusData || !categoryId) return true;

  return getSheetIdToTaggingTargetMap(taskStatusData)[categoryId] ?? true;
}
